module.exports = __webpack_public_path__ + "media/logos/hyundai 2-610972a2.svg";